import { Injectable } from '@angular/core';
import { ResponseCigoData } from '../shared/interfaces/cigo.interface';
import { ResponsePioData } from '../shared/interfaces/pio.interface';
import { GenericErrorType } from '../shared/enums';

@Injectable({
    providedIn: 'root'
})
export class DataNotClientService {

    constructor() { }

    private identificationType: string;
    private indentificationNumber: string;
    private phoneNumber: string;
    private email: string;
    private isCheckTermsCMR: boolean;
    private streetName: string;
    private streetNumber: string;
    private addressWithoutNumber: boolean;
    private buildingName: string;
    private flatNumber: string;
    private urbanizationType: string;
    private urbanizationName: string;
    private blockNumber: string;
    private lotNumber: string;
    private sectorName: string;
    private workActivityType: string;
    private dateEntryWork: string;
    private companyName: string;
    private rucCompany: string;
    private profession: string;
    private housingType: string;
    private countryBirth: string;
    private nationality: string;
    private residenceCountry: string;
    private taxResidence: string;
    private isPEP: boolean;
    private isFATCA: boolean;
    private isECR: boolean;
    private isFisherman: boolean;
    private accountType: string;
    private isCheckTermsBFPE: boolean;
    private isJointAccount: boolean;
    private identificationTypeJoint: string;
    private indentificationNumberJoint: string;
    private phoneNumberJoint: string;
    private emailJoint: string;
    private streetNameJoint: string;
    private streetNumberJoint: string;
    private addressWithoutNumberJoint: boolean;
    private buildingNameJoint: string;
    private flatNumberJoint: string;
    private urbanizationTypeJoint: string;
    private urbanizationNameJoint: string;
    private blockNumberJoint: string;
    private lotNumberJoint: string;
    private sectorNameJoint: string;
    private workActivityTypeJoint: string;
    private dateEntryWorkJoint: string;
    private companyNameJoint: string;
    private rucCompanyJoint: string;
    private professionJoint: string;
    private housingTypeJoint: string;
    private countryBirthJoint: string;
    private nationalityJoint: string;
    private residenceCountryJoint: string;
    private taxResidenceJoint: string;
    private isPEPJoint: boolean;
    private isFATCAJoint: boolean;
    private isECRJoint: boolean;
    private isFishermanJoint: boolean;
    private idRequestManager: string;
    private numberRequestManager: string;
    private fullname: string;
    private surname: string;
    private secondSurname: string;
    private birthday: string;
    private civilStatus: number;
    private gender: number;
    private isForeignClient: boolean;
    private fullnameJoint: string;
    private surnameJoint: string;
    private secondSurnameJoint: string;
    private birthdayJoint: string;
    private civilStatusJoint: number;
    private genderJoint: number;
    private isForeignClientJoint: boolean;
    private currencyType: number;
    private openingDate: string;
    private CCI: string;
    private accountNumber: string;
    private pioData: ResponsePioData;
    private pioDataJoint: ResponsePioData;
    private isCTS: boolean;
    private mainIsClient: boolean;
    private jointIsClient: boolean;
    private cigoData: ResponseCigoData;
    private cigoDataJoint: ResponseCigoData;
    private cigoState: string;
    private identifierFingerprint: string;
    private identifierFingerprintJoint: string;
    private fingerprintStatus: string;
    private fingerprintStatusJoint: string;
    private departmentCode: string;
    private departmentDescription: string;
    private provinceCode: string;
    private provinceDescription: string;
    private districtCode: string;
    private districtDescription: string;
    private departmentCodeJoint: string;
    private departmentDescriptionJoint: string;
    private provinceCodeJoint: string;
    private provinceDescriptionJoint: string;
    private districtCodeJoint: string;
    private districtDescriptionJoint: string;
    private isProspect: boolean;
    private redirectToBranch: boolean;
    private triSessionID: string;
    private canCreateProduct: boolean;
    private jointThroughFingerprint = false;
    private manualSignature = false;
    private genericErrorType: GenericErrorType = GenericErrorType.DEFAULT_ERROR;
    private isPasswordCreate = true;
    private canShowQR = false;
    private isRetake = false;
    private isRetakeActive = false;
    private useFlagr = false;

    public getPasswordState(): boolean {
        return this.isPasswordCreate;
    }

    public setPasswordState(isPasswordCreate: boolean): void {
        this.isPasswordCreate = isPasswordCreate;
    }

    public getGenericErrorType(): GenericErrorType {
        return this.genericErrorType;
    }

    public setGenericErrorType(genericErrorType: GenericErrorType): void {
        this.genericErrorType = genericErrorType;
    }
    public getTriSessionID(): string {
        return this.triSessionID;
    }

    public setTriSessionID(triSessionID: string): void {
        this.triSessionID = triSessionID;
    }

    public getFullname(): string {
        return this.fullname;
    }

    public setFullname(fullname: string): void {
        this.fullname = fullname;
    }

    public getFullnameJoint(): string {
        return this.fullnameJoint;
    }

    public setFullnameJoint(fullnameJoint: string): void {
        this.fullnameJoint = fullnameJoint;
    }

    public getSurname(): string {
        return this.surname;
    }

    public setSurname(surname: string): void {
        this.surname = surname;
    }

    public getSurnameJoint(): string {
        return this.surnameJoint;
    }

    public setSurnameJoint(surnameJoint: string): void {
        this.surnameJoint = surnameJoint;
    }

    public getSecondSurname(): string {
        return this.secondSurname;
    }

    public setSecondSurname(secondSurname: string): void {
        this.secondSurname = secondSurname;
    }

    public getSecondSurnameJoint(): string {
        return this.secondSurnameJoint;
    }

    public setSecondSurnameJoint(secondSurnameJoint: string): void {
        this.secondSurnameJoint = secondSurnameJoint;
    }

    public getBirthday(): string {
        return this.birthday;
    }

    public setBirthday(birthday: string): void {
        this.birthday = birthday;
    }

    public getBirthdayJoint(): string {
        return this.birthdayJoint;
    }

    public setBirthdayJoint(birthdayJoint: string): void {
        this.birthdayJoint = birthdayJoint;
    }

    public getCivilStatus(): number {
        return this.civilStatus;
    }

    public setCivilStatus(civilStatus: number): void {
        this.civilStatus = civilStatus;
    }

    public getCivilStatusJoint(): number {
        return this.civilStatusJoint;
    }

    public setCivilStatusJoint(civilStatusJoint: number): void {
        this.civilStatusJoint = civilStatusJoint;
    }

    public getGender(): number {
        return this.gender;
    }

    public setGender(gender: number): void {
        this.gender = gender;
    }

    public getGenderJoint(): number {
        return this.genderJoint;
    }

    public setGenderJoint(genderJoint: number): void {
        this.genderJoint = genderJoint;
    }

    public clientIsForeign(): boolean {
        return this.isForeignClient;
    }

    public setClientIsForeign(isForeignClient: boolean): void {
        this.isForeignClient = isForeignClient;
    }

    public jointIsForeign(): boolean {
        return this.isForeignClientJoint;
    }

    public setJointIsForeign(isForeignClientJoint: boolean): void {
        this.isForeignClientJoint = isForeignClientJoint;
    }

    public getCompanyNameJoint(): string {
        return this.companyNameJoint;
    }

    public setCompanyNameJoint(companyNameJoint: string): void {
        this.companyNameJoint = companyNameJoint;
    }

    public getRucCompanyJoint(): string {
        return this.rucCompanyJoint;
    }

    public setRucCompanyJoint(rucCompanyJoint: string): void {
        this.rucCompanyJoint = rucCompanyJoint;
    }

    public getProfessionJoint(): string {
        return this.professionJoint;
    }

    public setProfessionJoint(professionJoint: string): void {
        this.professionJoint = professionJoint;
    }

    public getCompanyName(): string {
        return this.companyName;
    }

    public setCompanyName(companyName: string): void {
        this.companyName = companyName;
    }

    public getRucCompany(): string {
        return this.rucCompany;
    }

    public setRucCompany(rucCompany: string): void {
        this.rucCompany = rucCompany;
    }

    public getProfession(): string {
        return this.profession;
    }

    public setProfession(profession: string): void {
        this.profession = profession;
    }

    public getStreetNameJoint(): string {
        return this.streetNameJoint;
    }

    public setStreetNameJoint(streetNameJoint: string): void {
        this.streetNameJoint = streetNameJoint;
    }

    public getStreetNumberJoint(): string {
        return this.streetNumberJoint;
    }

    public setStreetNumberJoint(streetNumberJoint: string): void {
        this.streetNumberJoint = streetNumberJoint;
    }

    public getBuildingNameJoint(): string {
        return this.buildingNameJoint;
    }

    public setBuildingNameJoint(buildingNameJoint: string): void {
        this.buildingNameJoint = buildingNameJoint;
    }

    public getFlatNumberJoint(): string {
        return this.flatNumberJoint;
    }

    public setFlatNumberJoint(flatNumberJoint: string): void {
        this.flatNumberJoint = flatNumberJoint;
    }

    public getUrbanizationTypeJoint(): string {
        return this.urbanizationTypeJoint;
    }

    public setUrbanizationTypeJoint(urbanizationTypeJoint: string): void {
        this.urbanizationTypeJoint = urbanizationTypeJoint;
    }

    public getUrbanizationNameJoint(): string {
        return this.urbanizationNameJoint;
    }

    public setUrbanizationNameJoint(urbanizationNameJoint: string): void {
        this.urbanizationNameJoint = urbanizationNameJoint;
    }

    public getBlockNumberJoint(): string {
        return this.blockNumberJoint;
    }

    public setBlockNumberJoint(blockNumberJoint: string): void {
        this.blockNumberJoint = blockNumberJoint;
    }

    public getLotNumberJoint(): string {
        return this.lotNumberJoint;
    }

    public setLotNumberJoint(lotNumberJoint: string): void {
        this.lotNumberJoint = lotNumberJoint;
    }

    public getSectorNameJoint(): string {
        return this.sectorNameJoint;
    }

    public setSectorNameJoint(sectorNameJoint: string): void {
        this.sectorNameJoint = sectorNameJoint;
    }

    public getWorkActivityTypeJoint(): string {
        return this.workActivityTypeJoint;
    }

    public setWorkActivityTypeJoint(workActivityTypeJoint: string): void {
        this.workActivityTypeJoint = workActivityTypeJoint;
    }

    public getDateEntryWorkJoint(): string {
        return this.dateEntryWorkJoint;
    }

    public setDateEntryWorkJoint(dateEntryWorkJoint: string): void {
        this.dateEntryWorkJoint = dateEntryWorkJoint;
    }

    public getCountryBirthJoint(): string {
        return this.countryBirthJoint;
    }

    public setCountryBirthJoint(countryBirthJoint: string): void {
        this.countryBirthJoint = countryBirthJoint;
    }

    public getNationalityJoint(): string {
        return this.nationalityJoint;
    }

    public setNationalityJoint(nationalityJoint: string): void {
        this.nationalityJoint = nationalityJoint;
    }

    public getResidenceCountryJoint(): string {
        return this.residenceCountryJoint;
    }

    public setResidenceCountryJoint(residenceCountryJoint: string): void {
        this.residenceCountryJoint = residenceCountryJoint;
    }

    public getTaxResidence(): string {
        return this.taxResidence;
    }

    public setTaxResidence(taxResidence: string): void {
        this.taxResidence = taxResidence;
    }

    public getTaxResidenceJoint(): string {
        return this.taxResidenceJoint;
    }

    public setTaxResidenceJoint(taxResidenceJoint: string): void {
        this.taxResidenceJoint = taxResidenceJoint;
    }

    public getCurrencyType(): number {
        return this.currencyType;
    }

    public setCurrencyType(currencyType: number): void {
        this.currencyType = currencyType;
    }

    public getIsPEPJoint(): boolean {
        return this.isPEPJoint;
    }

    public setIsPEPJoint(isPEPJoint: boolean): void {
        this.isPEPJoint = isPEPJoint;
    }

    public getIsFATCAJoint(): boolean {
        return this.isFATCAJoint;
    }

    public setIsFATCAJoint(isFATCAJoint: boolean): void {
        this.isFATCAJoint = isFATCAJoint;
    }

    public getIsECRJoint(): boolean {
        return this.isECRJoint;
    }

    public setIsECRJoint(isECRJoint: boolean): void {
        this.isECRJoint = isECRJoint;
    }

    public getIsFishermanJoint(): boolean {
        return this.isFishermanJoint;
    }

    public setIsFishermanJoint(isFishermanJoint: boolean): void {
        this.isFishermanJoint = isFishermanJoint;
    }

    public getIsECR(): boolean {
        return this.isECR;
    }

    public setIsECR(isECR: boolean): void {
        this.isECR = isECR;
    }

    public getIsFisherman(): boolean {
        return this.isFisherman;
    }

    public setIsFisherman(isFisherman: boolean): void {
        this.isFisherman = isFisherman;
    }

    public getIdentificationTypeJoint(): string {
        return this.identificationTypeJoint;
    }

    public setIdentificationTypeJoint(identificationTypeJoint: string): void {
        this.identificationTypeJoint = identificationTypeJoint;
    }

    public getIndentificationNumberJoint(): string {
        return this.indentificationNumberJoint;
    }

    public setIndentificationNumberJoint(indentificationNumberJoint: string): void {
        this.indentificationNumberJoint = indentificationNumberJoint;
    }

    public getPhoneNumberJoint(): string {
        return this.phoneNumberJoint;
    }

    public setPhoneNumberJoint(phoneNumberJoint: string): void {
        this.phoneNumberJoint = phoneNumberJoint;
    }

    public getEmailJoint(): string {
        return this.emailJoint;
    }

    public setEmailJoint(emailJoint: string): void {
        this.emailJoint = emailJoint;
    }

    public isIsJointAccount(): boolean {
        return this.isJointAccount;
    }

    public setIsJointAccount(isJointAccount: boolean): void {
        this.isJointAccount = isJointAccount;
    }

    public getAccountType(): string {
        return this.accountType;
    }

    public setAccountType(accountType: string): void {
        this.accountType = accountType;
    }

    public getIdentificationType(): string {
        return this.identificationType;
    }

    public setIdentificationType(identificationType: string): void {
        this.identificationType = identificationType;
    }

    public getIndentificationNumber(): string {
        return this.indentificationNumber;
    }

    public setIndentificationNumber(indentificationNumber: string): void {
        this.indentificationNumber = indentificationNumber;
    }

    public getPhoneNumber(): string {
        return this.phoneNumber;
    }

    public setPhoneNumber(phoneNumber: string): void {
        this.phoneNumber = phoneNumber;
    }

    public getEmail(): string {
        return this.email;
    }

    public setEmail(email: string): void {
        this.email = email;
    }

    public getDepartmentCode(): string {
        return this.departmentCode;
    }

    public setDepartmentCode(departmentCode: string): void {
        this.departmentCode = departmentCode;
    }

    public getDepartmentDescription(): string {
        return this.departmentDescription;
    }

    public setDepartmentDescription(departmentDescription: string): void {
        this.departmentDescription = departmentDescription;
    }

    public getProvinceCode(): string {
        return this.provinceCode;
    }

    public setProvinceCode(provinceCode: string): void {
        this.provinceCode = provinceCode;
    }

    public getProvinceDescription(): string {
        return this.provinceDescription;
    }

    public setProvinceDescription(provinceDescription: string): void {
        this.provinceDescription = provinceDescription;
    }

    public getDistrictCode(): string {
        return this.districtCode;
    }

    public setDistrictCode(districtCode: string): void {
        this.districtCode = districtCode;
    }

    public getDistrictDescription(): string {
        return this.districtDescription;
    }

    public setDistrictDescription(districtDescription: string): void {
        this.districtDescription = districtDescription;
    }

    public getDepartmentCodeJoint(): string {
        return this.departmentCodeJoint;
    }

    public setDepartmentCodeJoint(departmentCodeJoint: string): void {
        this.departmentCodeJoint = departmentCodeJoint;
    }

    public getDepartmentDescriptionJoint(): string {
        return this.departmentDescriptionJoint;
    }

    public setDepartmentDescriptionJoint(departmentDescriptionJoint: string): void {
        this.departmentDescriptionJoint = departmentDescriptionJoint;
    }

    public getProvinceCodeJoint(): string {
        return this.provinceCodeJoint;
    }

    public setProvinceCodeJoint(provinceCodeJoint: string): void {
        this.provinceCodeJoint = provinceCodeJoint;
    }

    public getProvinceDescriptionJoint(): string {
        return this.provinceDescriptionJoint;
    }

    public setProvinceDescriptionJoint(provinceDescriptionJoint: string): void {
        this.provinceDescriptionJoint = provinceDescriptionJoint;
    }

    public getDistrictCodeJoint(): string {
        return this.districtCodeJoint;
    }

    public setDistrictCodeJoint(districtCodeJoint: string): void {
        this.districtCodeJoint = districtCodeJoint;
    }

    public getDistrictDescriptionJoint(): string {
        return this.districtDescriptionJoint;
    }

    public setDistrictDescriptionJoint(districtDescriptionJoint: string): void {
        this.districtDescriptionJoint = districtDescriptionJoint;
    }

    public getStreetName(): string {
        return this.streetName;
    }

    public setStreetName(streetName: string): void {
        this.streetName = streetName;
    }

    public getStreetNumber(): string {
        return this.streetNumber;
    }

    public setStreetNumber(streetNumber: string): void {
        this.streetNumber = streetNumber;
    }

    public getBuildingName(): string {
        return this.buildingName;
    }

    public setBuildingName(buildingName: string): void {
        this.buildingName = buildingName;
    }

    public getFlatNumber(): string {
        return this.flatNumber;
    }

    public setFlatNumber(flatNumber: string): void {
        this.flatNumber = flatNumber;
    }

    public getUrbanizationType(): string {
        return this.urbanizationType;
    }

    public setUrbanizationType(urbanizationType: string): void {
        this.urbanizationType = urbanizationType;
    }

    public getUrbanizationName(): string {
        return this.urbanizationName;
    }

    public setUrbanizationName(urbanizationName: string): void {
        this.urbanizationName = urbanizationName;
    }

    public getBlockNumber(): string {
        return this.blockNumber;
    }

    public setBlockNumber(blockNumber: string): void {
        this.blockNumber = blockNumber;
    }

    public getLotNumber(): string {
        return this.lotNumber;
    }

    public setLotNumber(lotNumber: string): void {
        this.lotNumber = lotNumber;
    }

    public getSectorName(): string {
        return this.sectorName;
    }

    public setSectorName(sectorName: string): void {
        this.sectorName = sectorName;
    }

    public getWorkActivityType(): string {
        return this.workActivityType;
    }

    public setWorkActivityType(workActivityType: string): void {
        this.workActivityType = workActivityType;
    }

    public getDateEntryWork(): string {
        return this.dateEntryWork;
    }

    public setDateEntryWork(dateEntryWork: string): void {
        this.dateEntryWork = dateEntryWork;
    }

    public getCountryBirth(): string {
        return this.countryBirth;
    }

    public setCountryBirth(countryBirth: string): void {
        this.countryBirth = countryBirth;
    }

    public getNationality(): string {
        return this.nationality;
    }

    public setNationality(nationality: string): void {
        this.nationality = nationality;
    }

    public getResidenceCountry(): string {
        return this.residenceCountry;
    }

    public setResidenceCountry(residenceCountry: string): void {
        this.residenceCountry = residenceCountry;
    }

    public getIsPEP(): boolean {
        return this.isPEP;
    }

    public setIsPEP(isPEP: boolean): void {
        this.isPEP = isPEP;
    }

    public getIsFATCA(): boolean {
        return this.isFATCA;
    }

    public setIsFATCA(isFATCA: boolean): void {
        this.isFATCA = isFATCA;
    }

    public setCCI(CCI: string) {
        this.CCI = CCI;
    }

    public getCCI() {
        return this.CCI;
    }

    public setAccountNumber(AccountNumber: string) {
        this.accountNumber = AccountNumber;
    }

    public getAccountNumber() {
        return this.accountNumber;
    }

    public setPioData(PioData: ResponsePioData) {
        this.pioData = PioData;
    }

    public getPioData() {
        return this.pioData;
    }

    public setPioDataJoint(PioData: ResponsePioData) {
        this.pioDataJoint = PioData;
    }

    public getPioDataJoint() {
        return this.pioDataJoint;
    }

    public setCigoData(CigoData: ResponseCigoData) {
        this.cigoData = CigoData;
    }

    public getCigoData() {
        return this.cigoData;
    }

    public setCigoState(state: string) {
        this.cigoState = state;
    }

    public getCigoState(): string {
        return this.cigoState;
    }

    public setCigoDataJoint(CigoData: ResponseCigoData) {
        this.cigoDataJoint = CigoData;
    }

    public getCigoDataJoint() {
        return this.cigoDataJoint;
    }

    public setIsCTS(isCTS: boolean) {
        this.isCTS = isCTS;
    }

    public isIsCTS() {
        return this.isCTS;
    }

    public setMainIsClient(mainIsClient: boolean) {
        this.mainIsClient = mainIsClient;
    }

    public getMainIsClient() {
        return this.mainIsClient;
    }

    public setJointIsClient(jointIsClient: boolean) {
        this.jointIsClient = jointIsClient;
    }

    public getJointIsClient() {
        return this.jointIsClient;
    }

    public setIdentifierFingerprint(identifierFingerprint: string) {
        this.identifierFingerprint = identifierFingerprint;
    }

    public getIdentifierFingerprint() {
        return this.identifierFingerprint;
    }

    public setFingerprintStatus(fingerprintStatus: string) {
        this.fingerprintStatus = fingerprintStatus;
    }

    public getFingerprintStatus() {
        return this.fingerprintStatus;
    }

    public setIdentifierFingerprintJoint(identifierFingerprintJoint: string) {
        this.identifierFingerprintJoint = identifierFingerprintJoint;
    }

    public getIdentifierFingerprintJoint() {
        return this.identifierFingerprintJoint;
    }

    public getIsProspect(): boolean {
        return this.isProspect;
    }

    public setIsProspect(isProspect: boolean): void {
        this.isProspect = isProspect;
    }

    public setRedirectToBranch(redirectToBranch: boolean): void {
        this.redirectToBranch = redirectToBranch;
    }

    public getRedirectToBranch(): boolean {
        return this.redirectToBranch;
    }
    public setCanCreateProduct(can: boolean): void {
        this.canCreateProduct = can;
    }

    public getCanCreateProduct(): boolean {
        return this.canCreateProduct;
    }

    public setJointThroughFingerprint(through: boolean): void {
        this.jointThroughFingerprint = through;
    }

    public getJointThroughFingerprint(): boolean {
        return this.jointThroughFingerprint;
    }

    public getJointManualSignature(): boolean {
        return this.manualSignature;
    }

    public setShowQR(canShowQR: boolean): void {
        this.canShowQR = canShowQR;
    }

    public getShowQR(): boolean {
        return this.canShowQR;
    }

    public setIsRetakeActive(isRetakeActive) {
        this.isRetakeActive = isRetakeActive;
    }

    public getIsretakeActive(): boolean {
        return this.isRetakeActive;
    }

    public getIsRetake(): boolean {
        return this.isRetake;
    }

    public setIsRetake(isRetake: boolean) {
        this.isRetake = isRetake;
    }

    public getUseFlagr(): boolean {
        return this.useFlagr;
    }

    public setUseFlagr(useFlagr): void {
        this.useFlagr = useFlagr;
    }

    public setJointManualSignature(manualSignature: boolean): void {
        this.manualSignature = manualSignature;
    }
}
